// extracted by mini-css-extract-plugin
export default {"root":"sixth_root__Z51C+","top":"sixth_top__lQXuS","title":"sixth_title__KcnME","description":"sixth_description__mBvzy"};